import React from "react";
import Login from "../components/Login";

const PageLogin = () => {
  return (
    <div className="bg-gray-100 h-screen">
      <Login />
    </div>
  );
};

export default PageLogin;
